import React from "react";
import axios from "axios";
import { auth, provider, signInWithPopup } from "../firebase";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux"; 
import { login, isloading, loaded } from "../redux/authSlice"; 



const SignInButton = () => {
  const dispatch = useDispatch(); 
  const navigate = useNavigate();

  const handleGoogleSignIn = async () => {
    try {
      dispatch(isloading())
      const result = await signInWithPopup(auth, provider);
      const idToken = await result.user.getIdToken();
      
      const response = await axios.post("https://api-wish3s.vercel.app/auth/login", {
        token: idToken,
      });

      if (response.data.message === "login") {
        dispatch(login(response.data.jwtToken)); 
        dispatch(loaded())
        navigate("/");
      }
    } catch (error) {
      console.error("Error during Google Sign-In:", error);
    }
  };

  return (
    <button
      onClick={handleGoogleSignIn}
      className="px-4 py-2 bg-white text-black rounded hover:bg-grey transition"
    >
      Sign in with Google
    </button>
  );
};

export default SignInButton;
